/* ==========================================================================
   PARROTTY — sync the announcement bar's hide/reveal state with the
   header's own sticky-on-scroll-up behavior, so both move together.
   Purely observes class changes Dawn's existing StickyHeader element
   already makes on .section-header — no scroll listening of our own,
   so it can never fall out of sync with the header's real behavior.

   NOTE: looks up the announcement bar wrapper with an "ends with"
   attribute selector rather than assuming the exact literal ID
   "shopify-section-announcement-bar" — Shopify's section-group
   rendering can prefix that ID, so matching on the known suffix is more
   robust than a hardcoded guess.

   NURA FIX — measuring the announcement bar's height once on load (plus
   only on window resize) went stale in two real cases: (1) the marquee
   script (nura-announcement-marquee.js) rebuilds the bar's inner content
   after DOMContentLoaded, which can change its height; (2) web fonts
   swapping in after first paint (FOUT) can shift the text's rendered
   height slightly. Either one left the header positioned a few pixels
   too high, exposing a sliver of page content in the gap above it.
   A ResizeObserver tracks the bar's real height continuously instead of
   a one-time read, so the header offset stays correct no matter when or
   why the bar's height settles.
   ========================================================================== */
(function () {
  function findAnnouncementBar() {
    return (
      document.getElementById('shopify-section-announcement-bar') ||
      document.querySelector('[id$="announcement-bar"]')
    );
  }

  function init() {
    var header = document.querySelector('.section-header');
    var announcement = findAnnouncementBar();
    if (!header || !announcement) return;

    function setAnnouncementHeight() {
      document.documentElement.style.setProperty(
        '--nura-announcement-height',
        announcement.offsetHeight + 'px'
      );
    }

    setAnnouncementHeight();

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(setAnnouncementHeight);
      resizeObserver.observe(announcement);
    } else {
      /* Fallback for older browsers without ResizeObserver support */
      window.addEventListener('resize', setAnnouncementHeight);
      setTimeout(setAnnouncementHeight, 500);
      setTimeout(setAnnouncementHeight, 1500);
    }

    function sync() {
      var isSticky = header.classList.contains('shopify-section-header-sticky');
      var isHidden = header.classList.contains('shopify-section-header-hidden');
      var isAnimating = header.classList.contains('animate');

      announcement.classList.toggle('nura-announcement-sticky', isSticky);
      announcement.classList.toggle('nura-announcement-hidden', isHidden);
      announcement.classList.toggle('nura-announcement-animate', isAnimating);
    }

    sync();

    var observer = new MutationObserver(sync);
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
